import { ref } from 'vue';
import { useObservable } from '../functions/useObservable';
import { skip, take, lastValueFrom } from 'rxjs';
export function createGDKStore(gdk, gdkObj) {
    return Object.keys(gdkObj).reduce((store, key) => {
        const loading = ref(false);
        const subject = gdkObj[key].subject;
        const branch = gdkObj[key].branch;
        const initialValue = gdkObj[key].initialValue ?? null;
        const fetch = async (done) => {
            loading.value = true;
            gdk.trunk.trigger([branch]);
            await lastValueFrom(subject.pipe(skip(1), take(1)));
            loading.value = false;
            done?.();
        };
        void fetch();
        return {
            ...store,
            [key]: useObservable(subject, initialValue),
            [`${key}Loading`]: loading,
            [`fetch${key.charAt(0).toUpperCase() + key.slice(1)}`]: fetch
        };
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    }, {});
}
//# sourceMappingURL=createGDKStore.js.map